import { containerCss, headerCss, containerWithSeparatorCss, titleCss } from "./index.styles";

interface Props {
  title?: string;
  noSeparator?: boolean;
  children: React.ReactNode;
}

export const SearchBoxDropdownSection: React.FC<Props> = ({ title, children, noSeparator = false }) => {
  return (
    <aside css={noSeparator ? containerCss : containerWithSeparatorCss}>
      <div css={headerCss}>{title && <h5 css={titleCss}>{title}</h5>}</div>
      <div>{children}</div>
    </aside>
  );
};
